import React, { useState, useRef, useEffect } from 'react'
import Parser from 'html-react-parser';
// import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import useWindowSize from '../../../Hooks/useWindowSize'

// Mol
import Modal, { ModalSize } from '../../Modal'
// import MChannelsPartModal from '../../Modal/Part/MChannels'
import MServiceHomePartModal from '../../Modal/Part/MServiceHome'
import MSolicitarPartModal from '../../Modal/Part/MSolicitar'
import FormSolicitar from './formSolicitar';

import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { HttpClient } from 'actions/HttpClient';
import { RegisterRequestService } from 'actions/HttpCalls';

const httpClient = new HttpClient();
const registerRequestService = new RegisterRequestService(httpClient);

function General2PlanCardMol(props) {
    const {
        setSeEstaRegistrando,
        // showPlans,
        title,
        titlestyle,
        name,
        fi_PLAN,
        fc_DESCRIPCION,
        fi_PRECIO_PLAN,
        fc_ETIQUETA_PRECIO_TACHADO,
        fc_PRECIO_TACHADO,
        fc_NOTA_DEBAJO_PRECIO,
        fc_TEXTO_DETALLE,
        fc_URL_DETALLE,
        fc_TARGET_DETALLE,
        fc_TEXTO_CONTRATAR,
        fc_ETIQUETA_PERIODO,
        fc_TITULO_PROMO,
        Caracteristicas,
        caracteristicasPromocion,
        Acordeon,
        lstPlanContratacionxPlan,
        Discount,
        fi_INCLUIR_SECCION,
        fc_ETIQUETA_ROJA,
        fc_TITULO_SECCION,
        fc_DESCRIPCION_SECCION,
        fc_TEXTO_BOTON,
        fc_TARGET_BOTON,
        fc_URL_BOTON,
        fc_DESCRIPCION_OFERTA,
        fc_PLAN_ICONO,
        fc_NOTA_DETALLE_PROMOCION,
        // dataChannelsBk,
        // dataCategoriasBk,
        // dataPlanChannelsBk,
        tituloSolicitarPlan,
        descSolicitarPlan,
        changePlanSelected,
        planSelected,
        changeSolicitud,
    } = props
    let newAcordeon = Acordeon.map((item, index) => {
        if (!item?.open) {
            item.open = false
        }
        return item;
    })

    const cardPricesRef = useRef()

    const {
        // height: heightWindow,
        width: widthWindow,
    } = useWindowSize()
    const [disabledContinua, setDisabledContinua] = useState(false)
    // const [inputDisabled, setInputDisabled] = useState(false)
    const [errorCall, setErrorCall] = useState(false)

    let cotUsername = localStorage.getItem("cotUsername") ? localStorage.getItem("cotUsername") : null;
    let cotUsermail = localStorage.getItem("cotUsermail") ? localStorage.getItem("cotUsermail") : null;
    let cotUserphone = localStorage.getItem("cotUserphone") ? localStorage.getItem("cotUserphone") : null;

    function setDataReturn(data){
        changeSolicitud(data)
      }

      const [responseApi] = useState({idSolicitud: 0, fi_PLAN: 0})

    
    async function submintFormReques(idPlan){
        setSeEstaRegistrando(true);
        setDisabledContinua(true)
        // changePlanSelected(idPlan)
        localStorage.setItem("planName", name);
        document.getElementById('vwoButton')?.click();

        setTimeout(()=>{}, 200);

        const dataBody ={
            "fc_nombre" : cotUsername,
            "fc_correo" : cotUsermail,
            "fc_telefono" : cotUserphone,
            "fi_plan" : idPlan,
            "fc_nombre_plan" : name,
            "fc_seccion": localStorage.getItem("cotSeccion"),
            "sQueueName":localStorage.getItem("sQueueName"),
            "nombre":localStorage.getItem("nombre"),
            "stringDATA":localStorage.getItem("stringDATA"),
            "utmSOURCE":localStorage.getItem("utmSOURCE"),
            "utmMEDIUM":localStorage.getItem("utmMEDIUM"),
            "utmCAMPAING":localStorage.getItem("utmCAMPAING"),
            "utmCONTENT":localStorage.getItem("utmCONTENT"),
            "utmTERM":localStorage.getItem("utmTERM"),
            "aux1":localStorage.getItem("aux1"),
            "aux2":name,
            "aux3":localStorage.getItem("aux3"),
            "aux4":localStorage.getItem("aux4"),
            "aux5":localStorage.getItem("aux5"),
            "aux6":localStorage.getItem("aux6"),
            "aux7":localStorage.getItem("aux7"),
            "aux8":localStorage.getItem("aux8"),
            "aux9":localStorage.getItem("aux9"),
            "aux10":localStorage.getItem("aux10"),
        }
        var jsonSendData = JSON.stringify(dataBody);
        setDataReturn([{}]);

        const REGISTRAR_SOLICITUD_ENDPOINT = localStorage.getItem('url_envio_formulario') ? localStorage.getItem('url_envio_formulario') : "registraSolicitud";

        localStorage.setItem("userDataForm", JSON.stringify({
            body: jsonSendData,
            url: localStorage.getItem('url_servicio_web') + REGISTRAR_SOLICITUD_ENDPOINT
        }));
        console.log(localStorage.getItem("userDataForm"))

        if(localStorage.getItem("version_comparador") !== 'v2') {
            const RegistraSolicitud = registerRequestService.RegisterRequestItem(jsonSendData).then(response => {
                console.log("Nueva actualizacion", response)
                let data={
                    idSolicitud:parseInt(response),
                    nombres: cotUsername,
                    email: cotUsermail,
                    telefono: cotUserphone,
                    fi_PLAN: responseApi.idPlan,
                    name: name,
                    fcSeccion: localStorage.getItem("cotSeccion")
                }
                setDataReturn(data);
                setSeEstaRegistrando(false);
                setDisabledContinua(false);
                console.log("submintFormReques ", RegistraSolicitud)
            }).catch(error => {
                console.log("noentro")
                setErrorCall(true)
            });
        }else{
            setSeEstaRegistrando(false);
            setDisabledContinua(false);
        }
        
        // setInputDisabled(false)
    }

    const ajustarCard = function (className) {
        var altura, i, maxHeight, total;
        var els = document.getElementsByClassName(className)

        // Limpia todos los height
        Array.prototype.forEach.call(els, function (el) {
            el.style.height = ''
        });

        // Se optienen todos los height
        altura = [];
        total = els.length - 1
        i = 0;
        while (i <= total) {
            altura.push(els[i].offsetHeight);
            i++;
        }
        // Se optiene la height maxima entre todas las tarjetas
        maxHeight = Math.max.apply(null, altura);

        // Se aplica a todos la height
        Array.prototype.forEach.call(els, function (el) {
            // console.log(el.offsetHeight);
            el.style.height = maxHeight + 'px'
        });
    }

    // ajusta siempre que cambia
    useEffect(() => {
        ajustarCard('cPlanV2Head')
        ajustarCard('cPlanV2Prices')
        ajustarCard('cPlanV2Promo')
        ajustarCard('cPlanV2ContentDetails')

    })

    useEffect(() => {
        ajustarCard('cPlanV2Head')
        ajustarCard('cPlanV2Prices')
        ajustarCard('cPlanV2Promo')
        ajustarCard('cPlanV2ContentDetails')
    }, [widthWindow])

    const modalServiceRef = useRef()
    const modalRequestRef = useRef()
    const openModalService = () => modalServiceRef.current.open()
    const openModalRequest = () => modalRequestRef.current.open()

    const onClickSeeMore = () => {
        console.log('Conoce más')
        openModalService()
    }
    // eslint-disable-next-line
    const onClickRequest = () => {
        console.log('Contratar')
        openModalRequest()
    }

    // const modalChannelsRef = useRef()
	// const openModalChannels = () => modalChannelsRef.current.open()
	// const closeModalChannels = () => modalChannelsRef.current.close()

    // const onClickChangeChannels = () => {
	// 	openModalChannels()
	// }
	// const onClickChangeChannelsClose = () => {
	// 	closeModalChannels()
	// }

    const searchCharacteristics = (search, TypeFlag = false, Caracteristicas) => {
        let urlModChaCond = 0;
        if (TypeFlag) {
            const data = Caracteristicas?.length ? Caracteristicas : [];
            const newCaractData = data.filter(function (CaracData) {
                let CaracDESCRIPCION = []

                CaracDESCRIPCION = CaracData.fc_DESCRIPCION

                return CaracDESCRIPCION.indexOf(search) > -1
            })
            // console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
            return newCaractData
        } else {
            const data = Caracteristicas?.length ? Caracteristicas : [];
            const newCaractData = data.filter(function (CaracData) {
                let CaracDESCRIPCION = []

                CaracDESCRIPCION = CaracData.fc_DESCRIPCION

                return CaracDESCRIPCION.indexOf(search) === -1
            })
            let CaractCheckChannel = newCaractData
            CaractCheckChannel.forEach((c, index)=>{
        
                if(c.fc_TITULO.toLowerCase().indexOf("canal")>-1 && urlModChaCond === 0 && c?.SETURLMODCH === undefined){
                    c.SETURLMODCH = true
                    urlModChaCond = 1
                }
            })
            // console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
            return newCaractData
        }
    }
    // const getChannesByPlanId = async (IdPlan) => {
    //     let channels = []
    //     let categorias =[]
    //     const PlanDataById = dataPlanChannelsBk.filter(cp => cp.fi_plan === IdPlan)
    //     if(PlanDataById.length){
    //         let ChannelsIncludes = [];
    //         let arrayChannels = [];
    //         PlanDataById.forEach((c, index) =>{
    //             let arrayFilt = c.lstCanalxPlan
    //             return ( arrayFilt.length ? arrayChannels = c.lstCanalxPlan : null)
    //         });
    //         console.log("getChannesByPlanId arrayChannels: ", IdPlan, arrayChannels)
    //         arrayChannels.forEach((ac , index) =>{
    //             if(!ChannelsIncludes.includes(ac.fi_canal)){
    //                 ChannelsIncludes.push(ac.fi_canal)
    //             }
    //         })
    //         channels = dataChannelsBk.filter(c => ChannelsIncludes.includes(c.fi_canal))
    //     }
    //     if (channels.length){
    //         let catIncludes =[];
    //         channels.forEach((c, index)=>{
    //             catIncludes.push(c.fi_categoria)
    //         })
    //         categorias = dataCategoriasBk.filter(ca => catIncludes.includes(ca.fi_categoria))
    //     }
    //     setDataChannels(channels)
    //     setDataCategorias(categorias)

    //     console.log("getChannesByPlanId listChannels General2", IdPlan, channels, PlanDataById)
    // }
    // useEffect(() => {
    //     getChannesByPlanId(fi_PLAN)
    //     // eslint-disable-next-line
    // }, [])
    // const [dataChannels, setDataChannels] = useState([])
    // const [dataCategorias, setDataCategorias] = useState([])

    const [detailsCond, setDetailsCond] = useState(false)
    let CharactBlock = searchCharacteristics('Tipo Footer', false, Caracteristicas)
    let CharactFooter = searchCharacteristics('Tipo Footer', true, Caracteristicas)
    const symbolPrice = "$";
    
    const checkIfUserDataIsset = (fi_PLAN) => {
        cotUsername = localStorage.getItem("cotUsername") ? localStorage.getItem("cotUsername") : null;
        cotUsermail = localStorage.getItem("cotUsermail") ? localStorage.getItem("cotUsermail") : null;
        cotUserphone = localStorage.getItem("cotUserphone") ? localStorage.getItem("cotUserphone") : null;

        if(cotUserphone && cotUsermail && cotUsername) {
            submintFormReques(fi_PLAN);
            return;
        }

        changePlanSelected(fi_PLAN);
    }
    // let flagModChannel = localStorage.getItem('id_vigencia') === "CHN" ? true : false;
    return (
        <>
            <div className={'cPlanV2Wrap ' + (titlestyle ? titlestyle : 'amarillo') + (planSelected === fi_PLAN && (!cotUsername && !cotUsermail && !cotUserphone) ? ' expanded' : '')}>
                <div className="cPlanV2">
                    {
                        title
                            ?
                            <div className="cPlanV2Flag">
                                <p>{title}</p>
                            </div>
                            :
                            null
                    }
                    <div className="cPlanV2Head">
                        <div className="cPlanV2Icon">
                            {
                                fc_PLAN_ICONO
                                    ?
                                    <i className={fc_PLAN_ICONO}></i>
                                    : null
                            }
                        </div>
                        <div className="cPlanV2HeadCont">
                            <h3 className="h3">{name}</h3>
                            <div className="cPlanV2HeadInf">
                                {
                                    fc_DESCRIPCION ?
                                        <p>
                                            {fc_DESCRIPCION}
                                        </p>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cPlanV2Prices" ref={cardPricesRef}>
                        <div className="cPlanV2PricesTitle">
                            {
                                fc_DESCRIPCION_OFERTA
                                    ?
                                    <p>{fc_DESCRIPCION_OFERTA}</p>

                                    : null
                            }
                        </div>
                        <div className="cPlanV2PricesPrice">
                            {
                                fi_PRECIO_PLAN ?
                                    <p>
                                        {symbolPrice}{fi_PRECIO_PLAN}
                                    </p>
                                    : null
                            }
                        </div>
                        <div className="cPlanV2PricesTime">
                            {
                                fc_ETIQUETA_PERIODO ?
                                    <p>
                                        {fc_ETIQUETA_PERIODO}
                                    </p>
                                    : null
                            }
                        </div>
                        <div className="cPlanV2PricesNote">
                            {
                                fc_ETIQUETA_PRECIO_TACHADO && fc_PRECIO_TACHADO ?

                                    <p>{fc_ETIQUETA_PRECIO_TACHADO}: {symbolPrice} <del>{fc_PRECIO_TACHADO}</del></p>

                                    : null
                            }
                        </div>

                        {
                            fc_NOTA_DEBAJO_PRECIO ?
                                <div className="cPlanV2PricesPlaque">
                                    <p>{Parser(fc_NOTA_DEBAJO_PRECIO)}</p>
                                </div>
                                : null
                        }
                        {
                            Discount != null ?
                                <div className="cPlanV2Tag">
                                    <picture>
                                        <source media="(max-width: 640px)" data-srcset="/portal/ec/recursos_tema/assets/img/cardPlanV2Disc.webp" type="image/webp" />
                                        <source media="(max-width: 640px)" data-srcset="/portal/ec/recursos_tema/assets/img/cardPlanV2Disc.png" type="image/jpeg" />
                                        <source media="(min-width: 640px)" data-srcset="/portal/ec/recursos_tema/assets/img/cardPlanV2Disc.webp" type="image/webp" />
                                        <source media="(min-width: 640px)" data-srcset="/portal/ec/recursos_tema/assets/img/cardPlanV2Disc.png" type="image/jpeg" />
                                        <img className="lazyload" data-src="/portal/ec/recursos_tema/assets/img/cardPlanV2Disc.png" alt="" width="100" height="55" />
                                    </picture>

                                    <div className='cPlanV2TagCont'>
                                        <div className="cPlanV2TagNumber">
                                            <p>{Discount}</p>
                                        </div>
                                        <div className='cPlanV2TagPor'>
                                            <p className='disc'>%</p>
                                            <p className='note'>DCTO</p>
                                        </div>
                                    </div>

                                </div>
                                :
                                <div className="cPlanV2Tag"></div>
                        }

                    </div>
                    {
                        fc_TITULO_PROMO || caracteristicasPromocion?.length
                            ?
                            <div className="cPlanV2Promo">
                                <p>{fc_TITULO_PROMO ? fc_TITULO_PROMO : null}</p>
                                <div className="cPlanV2PromoItems">
                                    {
                                        caracteristicasPromocion?.length
                                            ?
                                            caracteristicasPromocion.map((caract, index) => (
                                                caract?.fc_TIPO_VALOR_CARACTERISTICA.includes("IMG") ?
                                                    <picture key={uuid()}>
                                                        <source media="(max-width: 640px)" data-srcset={caract?.fc_VALOR.split(".")[0] + ".webp"} type="image/webp" />
                                                        <source media="(max-width: 640px)" data-srcset={caract?.fc_VALOR} type={"image/" + caract?.fc_VALOR.split(".")[1]} />
                                                        <source media="(min-width: 640px)" data-srcset={caract?.fc_VALOR.split(".")[0] + ".webp"} type="image/webp" />
                                                        <source media="(min-width: 640px)" data-srcset={caract?.fc_VALOR} type={"image/" + caract?.fc_VALOR.split(".")[1]} />
                                                        <img className="lazyload" data-src={caract?.fc_VALOR} alt={caract?.fc_ALT_IMG} width="75" height="25" />
                                                    </picture>
                                                    :
                                                    <i key={uuid()} className={caract?.fc_VALOR}></i>
                                            ))
                                            : null
                                    }
                                </div>
                            </div>
                            : null
                    }
                    <div className={`cPlanV2Content cPlanV2ContentMore ${detailsCond ? 'openDetails' : ''}`}>
                        <div className="cPlanV2ContentOpen" onClick={() => { setDetailsCond(c => !c) }}>
                            <p>Ver detalle de plan</p>
                            <i className="ico-chevron-down"></i>
                        </div>

                        <div className="cPlanV2ContentDetails">
                            {
                                CharactBlock ?
                                    CharactBlock.map((caract, index) => (
                                        caract.fc_VALOR.includes("logo") ?
                                            <dl key={uuid()} className="cPlanV2DL">

                                                <dt>
                                                    <span className={`${caract.fc_VALOR}`}></span>
                                                </dt>
                                                <dd>{caract.fc_TITULO}</dd>
                                            </dl>
                                            :
                                            <dl key={uuid()} className={`cPlanV2DL ${caract.fc_CLASE_ICONO && !caract.fc_DESCRIPCION.includes("Redes Sociales") ? 'iconEle' : ''}`}>

                                                {
                                                    caract.fc_CLASE_ICONO
                                                        ?
                                                        <dt>
                                                            {
                                                                caract.fc_DESCRIPCION.includes("Redes Sociales")
                                                                    ? null
                                                                    :<i className={caract.fc_CLASE_ICONO}></i>
                                                            }
                                                            <span>{caract.fc_TITULO}</span>
                                                        </dt>
                                                        :
                                                        <dt>
                                                            {caract.fc_TITULO}
                                                        </dt>
                                                }

                                                {
                                                    caract.fc_DESCRIPCION.includes("Redes Sociales")
                                                        ?
                                                        <dd className="cPlanRedS">
                                                            <ul>
                                                                {
                                                                    caract.fc_VALOR.split("|").map((icoRed, index) => (
                                                                        <li key={uuid()}>
                                                                            <span>
                                                                                <i className={icoRed} />
                                                                            </span>
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </dd>
                                                        :
                                                        <dd>
                                                            {
                                                                // dataChannels.length > 0 && caract.fc_TITULO.toLowerCase().indexOf("canal") >-1 && 
                                                                // caract?.SETURLMODCH === true > -1  && flagModChannel ?
                                                                // <>
                                                                //     <span className="ddExtra">{caract.fc_VALOR}</span>
                                                                //     <a href="#!" className="textLink" onClick={()=>{onClickChangeChannels()}}>Ver canales</a>
                                                                // </>
                                                                // :
                                                                caract.fc_VALOR
                                                            }
                                                        </dd>
                                                }
                                            </dl>
                                    ))

                                    : null
                            }
                            {
                                CharactFooter ?
                                    CharactFooter.map((caract, index) => (
                                        <div key={uuid()} className="cPlanIconBlock">
                                            <span className="iconCircle">
                                                {
                                                    caract.fc_CLASE_ICONO ?
                                                        <i className={caract.fc_CLASE_ICONO}></i>
                                                        : null
                                                }

                                            </span>
                                            <p>
                                                <strong> {caract.fc_TITULO}</strong>
                                                <span> {caract.fc_VALOR}</span>
                                            </p>
                                        </div>
                                    ))
                                    : null
                            }
                            <dl className="cPlanV2DL">
                                <div className="cPlanV2DLAction">
                                    {
                                        fc_TEXTO_DETALLE ?
                                            fc_URL_DETALLE !== "$URL_DEFAULT_DETALLE$"
                                                ?
                                                <a href={fc_URL_DETALLE} target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"}>
                                                    {fc_TEXTO_DETALLE}
                                                </a>
                                                :
                                                <a href="#!" target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"} onClick={() => onClickSeeMore()}>
                                                    {fc_TEXTO_DETALLE}
                                                </a>
                                            : null
                                    }
                                </div>
                            </dl>
                        </div>

                        <div className="cPlanV2ContentClose" onClick={() => { setDetailsCond(c => !c) }}>
                            <p>Ocultar</p>
                            <i className="ico-chevron-up"></i>
                        </div>
                    </div>
                    <div className="cPlanV2Actions">
                        {
                            cotUsername && cotUsermail && cotUserphone
                            ?
                                fc_TEXTO_DETALLE ?
                                    <>
                                    <a className="btn btnPrimario" href="#!" onClick={() => submintFormReques(fi_PLAN)} target={'_self'} disabled={disabledContinua}>
                                        {disabledContinua ? "Enviando..." : fc_TEXTO_CONTRATAR}
                                    </a>
                                    {
                                        errorCall &&
                                        <span name="errorCall" class="errorField ">Ha ocurrido un error, vuelva a intentarlo</span>
                                    }
                                    </>
                                :null
                            :
                                fc_TEXTO_DETALLE ?
                                    <a className="btn btnPrimario" href="#!" onClick={() => checkIfUserDataIsset(fi_PLAN)} target={'_self'}>
                                        {fc_TEXTO_CONTRATAR}
                                    </a>
                                :null
                        }
                    </div>
                </div>
                {
                    fi_INCLUIR_SECCION === 1
                        ?
                        <div className="cPlanV2Offer cPlanV2OfferShow">
                            <p className="cPlanV2OfferLeft">{fc_ETIQUETA_ROJA}</p>
                            <div className="cPlanV2OfferCont">
                                <p>{fc_TITULO_SECCION}</p>
                                <p>{fc_DESCRIPCION_SECCION}</p>
                                <div className="cPlanV2OfferAction">
                                    <a href={fc_URL_BOTON} target={fc_TARGET_BOTON ? fc_TARGET_BOTON : '_self'}>
                                        {fc_TEXTO_BOTON}
                                        <i className="ico-chevron-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        : null
                }
                {
                    !cotUsername && !cotUsermail && !cotUserphone &&
                    <FormSolicitar
                        tituloSolicitarPlan={tituloSolicitarPlan}
                        descSolicitarPlan={descSolicitarPlan}
                        fi_PLAN={fi_PLAN}
                        planSelected={planSelected}
                        name={name}
                        changeSolicitud={changeSolicitud}
                    />
                }
            </div>
            {/* <Modal 
				ref={modalChannelsRef}
				size={ModalSize.BIG}
			>
				<MChannelsPartModal
					onClose={onClickChangeChannelsClose}
					dataChannels={dataChannels}
					planName={name + " " + fc_DESCRIPCION}
                    dataCategorias={dataCategorias}
				/>
			</Modal> */}
            <Modal
                ref={modalServiceRef}
                size={ModalSize.MEDIUM_2}
            >
                <MServiceHomePartModal
                    asks={newAcordeon}
                    Caracteristicas={Caracteristicas}
                    title={title}
                    name={name}
                    fc_DESCRIPCION={fc_DESCRIPCION}
                    fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                    fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                    titlestyle={titlestyle}
                    fc_TITULO_PROMO={fc_TITULO_PROMO}
                    caracteristicasPromocion={caracteristicasPromocion}
                    symbolPrice={symbolPrice}
                    fc_NOTA_DETALLE_PROMOCION={fc_NOTA_DETALLE_PROMOCION}
                />
            </Modal>
            <Modal
                ref={modalRequestRef}
                size={ModalSize.SMALL}
            >
                <MSolicitarPartModal
                    title={title}
                    name={name}
                    fc_DESCRIPCION={fc_DESCRIPCION}
                    fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                    fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                    lstPlanContratacionxPlan={lstPlanContratacionxPlan}
                />
            </Modal>
        </>
    )
}

export default General2PlanCardMol
